import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`${prefix}.Equipment.Balance`);
  const dryMassBalance = wrap(`${prefix}.Equipment.DryMassBalance`);
  const measurementBalance = wrap(`${prefix}.Equipment.MeasurementBalance`);

  return {
    [`${prefix}.Preparation.TareMass`]: balance,
    [`${prefix}.Preparation.TarePlusSampledMass`]: balance,
    [`${prefix}.Preparation.SampledMass`]: balance,

    [`${prefix}.TestPortions.MoistureDetermination.DryingTray.ContainerMass`]: balance,
    [`${prefix}.TestPortions.MoistureDetermination.DryingTray.WetSoilAndContainerMass`]: balance,
    [`${prefix}.TestPortions.MoistureDetermination.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: dryMassBalance,

    [`${prefix}.Measurements.TestMeasurements.EmptyGasJarAndLidMass`]: measurementBalance,
    [`${prefix}.Measurements.TestMeasurements.GasJarLidAndSpecimenMass`]: measurementBalance,
    [`${prefix}.Measurements.TestMeasurements.GasJarLidSpecimenAndWaterMass`]: measurementBalance,
    [`${prefix}.Measurements.TestMeasurements.GasJarLidAndWaterMass`]: measurementBalance,
    [`${prefix}.Measurements.EmptyBasketMassInWater`]: measurementBalance,
    [`${prefix}.Measurements.BasketAndTestPortionMassInWater`]: measurementBalance,
  };
};

export default getMeasuredUsingConfig;
